WiseMetering.Views.ContractCosts = Backbone.Marionette.Layout.extend({
    template: 'templates/utilities/costs',
    regions: {
        container: '#utility-costs-container'
    },

    onShow: function() {
        const costView = new WiseMetering.Views.Costs({
            minDate: this.model.get('start'),
            maxDate: this.model.get('finish'),
            model: this.model
        });

        this.container.show(costView);
    }
});
